import { render, staticRenderFns } from "./ServiceCardView.vue?vue&type=template&id=8c2bb762&scoped=true"
import script from "./ServiceCardView.vue?vue&type=script&lang=ts"
export * from "./ServiceCardView.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCardView.vue?vue&type=style&index=0&id=8c2bb762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2bb762",
  null
  
)

export default component.exports